import isObjectWithKey from "./isObjectWithKey";

/**
 * Whether there is an earlier in-app history entry that navigate(-1) would
 * return to. React Router's BrowserRouter stores the entry's index in
 * history.state; it starts at 0 for the app's first entry, increments on
 * push, and is preserved on replace. location.key can't be used for this
 * because a replace on the first entry gives it a non-default key.
 */
export default function hasInAppHistory(): boolean {
  const { state } = window.history;
  return (
    isObjectWithKey(state, "idx") &&
    typeof state.idx === "number" &&
    state.idx > 0
  );
}
